import React from 'react';
import { captureException } from '@sentry/node';
import { NextPage } from 'next';

import Layout from '@r1-frontend/entities/Layout';

import ErrorContainer from '~/src/features/_error';

interface IErrorPage {
    statusCode: number,
}

const ErrorPage: NextPage<IErrorPage> = ({ statusCode }) => {
    return (
        <Layout
            title='Страница не найдена'
            description='Страница не найдена'
            withMenu={false}
            withFooter={false}
        >
            <ErrorContainer statusCode={statusCode}/>
        </Layout>
    );
};

ErrorPage.getInitialProps = async(options) => {
    const { res, err } = options;

    /**
     * If a user arrives at the Error page with CSR, it would be appropriate
     * to pass a 404 status code to the frontend application.
     * This is not a real status code. Google Analytics will use it
     * to log clients who have encountered an error.
     */
    const statusCode = res?.statusCode || 404;

    if (statusCode !== 404) {
        captureException(err);
    }

    return { statusCode };
};

export default ErrorPage;
